/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
import { useState } from "react";
import { Link } from "react-router-dom";
import { Eye, EyeOff } from "lucide-react";
import { useSelectedUser } from "../../staff/SelectedUserProvider";
import logoBw from "../../../assets/logo-bw.png";


const Login = () => {

    const { handleLoginUser, isLoggingIn } = useSelectedUser();

    const [loginPayload, setLoginPayload] = useState({ username: '', password: '' });

    const [passwordVisible, setPasswordVisible] = useState(true);

    const togglePasswordVisibility = () => {
        setPasswordVisible(!passwordVisible);
    };

    const handleChange = (e) => {
        const { name, value } = e.target;

        setLoginPayload({ ...loginPayload, [name]: value });
    };

    const handleLogin = (e) => {
        e.preventDefault();

        if (isLoggingIn) {
            return;
        }

        handleLoginUser(loginPayload);
    };

    return (
        <div className="main-wrapper login-body">
            <div className="container-fluid px-0">
                <div className="row g-0">
                    <div className="col-lg-6 d-none d-lg-flex bela-login-panel">
                        <div className="bela-brand-block">
                            <div className="bela-brand-logo" aria-label="Synergy HMS">
                                <span className="bela-brand-logo-mark">
                                    <img src={logoBw} alt="" />
                                </span>
                                <span className="bela-brand-logo-text">SYNERGY HMS</span>
                            </div>
                            <p className="bela-brand-tagline">
                                Hospital Management System — streamlined care, smarter operations.
                            </p>
                            <ul className="bela-brand-features">
                                <li>
                                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" aria-hidden="true">
                                        <path strokeLinecap="round" strokeLinejoin="round" d="M18 7.5v3m0 0v3m0-3h3m-3 0h-3m-2.25-4.125a3.375 3.375 0 1 1-6.75 0 3.375 3.375 0 0 1 6.75 0ZM3 19.235v-.11a6.375 6.375 0 0 1 12.75 0v.109A12.318 12.318 0 0 1 9.374 21c-2.331 0-4.512-.645-6.374-1.766Z" />
                                    </svg>
                                    Patient records &amp; clinical workflows
                                </li>
                                <li>
                                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" aria-hidden="true">
                                        <path strokeLinecap="round" strokeLinejoin="round" d="M19.5 14.25v-2.625a3.375 3.375 0 0 0-3.375-3.375h-1.5A1.125 1.125 0 0 1 13.5 7.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H8.25m3.75 9v6m3-3H9m1.5-12H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 0 0-9-9Z" />
                                    </svg>
                                    Role-based dashboards &amp; reporting
                                </li>
                                <li>
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
                                        <path fillRule="evenodd" d="M3 2.25a.75.75 0 0 0 0 1.5v16.5h-.75a.75.75 0 0 0 0 1.5H15v-18a.75.75 0 0 0 0-1.5H3ZM6.75 19.5v-2.25a.75.75 0 0 1 .75-.75h3a.75.75 0 0 1 .75.75v2.25a.75.75 0 0 1-.75.75h-3a.75.75 0 0 1-.75-.75ZM6 6.75A.75.75 0 0 1 6.75 6h.75a.75.75 0 0 1 0 1.5h-.75A.75.75 0 0 1 6 6.75ZM6.75 9a.75.75 0 0 0 0 1.5h.75a.75.75 0 0 0 0-1.5h-.75ZM6 12.75a.75.75 0 0 1 .75-.75h.75a.75.75 0 0 1 0 1.5h-.75a.75.75 0 0 1-.75-.75ZM10.5 6a.75.75 0 0 0 0 1.5h.75a.75.75 0 0 0 0-1.5h-.75Zm-.75 3.75A.75.75 0 0 1 10.5 9h.75a.75.75 0 0 1 0 1.5h-.75a.75.75 0 0 1-.75-.75ZM10.5 12a.75.75 0 0 0 0 1.5h.75a.75.75 0 0 0 0-1.5h-.75ZM16.5 6.75v15h5.25a.75.75 0 0 0 0-1.5H21v-12a.75.75 0 0 0 0-1.5h-4.5Zm1.5 4.5a.75.75 0 0 1 .75-.75h.008a.75.75 0 0 1 .75.75v.008a.75.75 0 0 1-.75.75h-.008a.75.75 0 0 1-.75-.75v-.008Zm.75 2.25a.75.75 0 0 0-.75.75v.008c0 .414.336.75.75.75h.008a.75.75 0 0 0 .75-.75v-.008a.75.75 0 0 0-.75-.75h-.008ZM18 17.25a.75.75 0 0 1 .75-.75h.008a.75.75 0 0 1 .75.75v.008a.75.75 0 0 1-.75.75h-.008a.75.75 0 0 1-.75-.75v-.008Z" clipRule="evenodd" />
                                    </svg>
                                    Secure multi-branch access
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div className="col-lg-6 col-12 bela-login-form-wrap">
                        <div className="bela-login-card">
                            <div className="d-lg-none bela-login-form-brand mb-4" aria-label="Synergy HMS">
                                <span className="bela-login-form-brand-logo">
                                    <img src={logoBw} alt="" />
                                </span>
                                <span className="bela-login-form-brand-name">SYNERGY HMS</span>
                            </div>
                            <h2>Sign in</h2>
                            <p className="bela-login-subtitle">Enter your credentials to access HMS</p>
                            <form onSubmit={handleLogin}>
                                <div className="form-group mb-3">
                                    <label className="bela-form-label">
                                        Username <span className="login-danger">*</span>
                                    </label>
                                    <input
                                        className="form-control"
                                        type="text"
                                        name="username"
                                        placeholder="Username or phone number"
                                        value={loginPayload.username}
                                        onChange={handleChange}
                                        autoComplete="username"
                                        required
                                    />
                                </div>
                                <div className="form-group mb-3">
                                    <label className="bela-form-label">
                                        Password <span className="login-danger">*</span>
                                    </label>
                                    <div className="position-relative">
                                        <input
                                            type={passwordVisible ? 'password' : 'text'}
                                            placeholder="Password"
                                            className="form-control pass-input"
                                            name="password"
                                            value={loginPayload.password}
                                            onChange={handleChange}
                                            autoComplete="current-password"
                                            required
                                        />
                                        <span className="toggle-password" onClick={togglePasswordVisibility}>
                                            {passwordVisible
                                                ? <EyeOff className="react-feather-custom" />
                                                : <Eye className="react-feather-custom" />}
                                        </span>
                                    </div>
                                </div>
                                <div className="forgotpass d-flex justify-content-between align-items-center mb-4">
                                    <label className="custom_check mr-2 mb-0 d-inline-flex remember-me">
                                        Remember me
                                        <input type="checkbox" name="remember" />
                                        <span className="checkmark" />
                                    </label>
                                    <Link to="/forgotpassword">Forgot Password?</Link>
                                </div>
                                <div className="form-group login-btn mb-0">
                                    <button
                                        type="submit"
                                        className="btn btn-primary btn-block w-100"
                                        disabled={isLoggingIn}
                                    >
                                        {isLoggingIn
                                            ? <><span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true" />Logging in...</>
                                            : 'Login'}
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Login;
